import React, { FC } from 'react'
import scrollTo from 'gatsby-plugin-smoothscroll'
import ButtonBase from '@material-ui/core/ButtonBase'

import StylesModule from 'components/lv1/ImageScrollButton.module.scss'

import Logo from 'images/logo-only.svg'

export interface ImageScrollButtonProps {
  target: string
  text: string
  image: string
}

const ImageScrollButton: FC<ImageScrollButtonProps> = ({
  target,
  text,
  image,
}) => {
  const link = `#${target}`
  return (
    <span className={StylesModule.imageScrollButton}>
      <ButtonBase
        focusRipple
        key=""
        className={StylesModule.imageScrollButton__button}
        focusVisibleClassName="{classes.focusVisible}"
        onClick={() => scrollTo(link)}
      >
        <div className={StylesModule.imageScrollButton__hover}> </div>
        <div className={StylesModule.imageScrollButton__text}>{text}</div>
        <img
          src={Logo}
          className={StylesModule.imageScrollButton__logo}
          area-hidden="true"
          alt=""
        />
        <div className={StylesModule.imageScrollButton__bgCover}> </div>
        <img
          src={image}
          className={StylesModule.imageScrollButton__bg}
          area-hidden="true"
          alt=""
        />
      </ButtonBase>
    </span>
  )
}

export default ImageScrollButton
